import React from "react";
import "./About.scss";
import Michael from "../assets/images/about_michael.gif";
import Resume from "../assets/documents/MichaelSmithResume.pdf";

function About() {
  return (
    <>
      <div>
        <div id="about-body">
          <img
            src={Michael}
            alt=""
            className="about-michael-img fade-in one"
          />
          <div id="about-info">
            <h1 className="fade-in two">ABOUT MICHAEL SMITH</h1>
            <p className="fade-in three">
              I'm a Frontend Engineer with 6+ years of experience building
              websites and web applications using HTML, CSS, JavaScript, and
              React.js. I focus on creating fast,
              easy-to-use interfaces and helping connect frontend applications
              with the systems that power modern ecommerce sites.
              <br />
              <br />
              I've delivered 200+ client implementations using Searchspring's
              open-source SDK (SNAP), building real-time search and discovery
              experiences for major global ecommerce brands. My work involves
              developing complex integrations with proprietary APIs and SDKs,
              leveraging technologies like React, Sass, and Webpack to
              implement advanced search and merchandising features across
              multiple ecommerce platforms.
              <br />
              <br />
              Beyond development, I've led a frontend engineering team of
              five, fostering a culture of technical excellence through
              mentorship, collaborative workflows, and standardized code
              quality practices. I've also led onboarding and technical
              training for new engineers, helping teams adopt Searchspring's
              SDK and implementation workflows efficiently.
              <br />
              <br />
              Throughout the implementation lifecycle, I've served as the
              primary technical point of contact for clients, guiding projects
              from scoping and development through QA, launch, and
              post-deployment support. I've also contributed to technical
              documentation and knowledge-base resources to improve internal
              processes and team productivity.
              <br />
              <br />
              Creativity has always been central to my life. Before becoming a
              developer, I spent years working in tech building computers and
              supporting networks, which ultimately led me to combine my
              passion for creativity and technology through web development. I
              completed the Web Development Immersive program at Galvanize in
              Denver, where I strengthened my ability to learn new
              technologies quickly and tackle complex challenges.
              <br />
              <br />
              My background in music taught me that there are often multiple
              ways to solve a problem—an approach that continues to shape how
              I design and build software. I enjoy creating interfaces that
              are clean, thoughtful, and enjoyable to use, and I love taking a
              project from concept all the way through launch.
              <br />
              <br />
              Outside of work, I enjoy playing drums, collecting records,
              woodworking, and spending time with my wife and two daughters.
              These creative outlets continually inspire the way I approach
              development and problem-solving.
              <br />
              <br />
              I'm always excited to connect with other developers, teams, and
              companies building meaningful products. If you'd like to
              collaborate or discuss opportunities, feel free to reach out.
            </p>
            <div className="about-download-container fade-in three">
              <a href={Resume} download>
                <span className="about-icon far fa-file" />
                <div className="about-download-text">
                  <h3>DOWNLOAD RESUME</h3>
                  <span>Michael Smith</span>
                </div>
              </a>
              <a
                href="https://youtu.be/HKYp97iAoQc"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="about-icon fas fa-video" />
                <div className="about-download-text">
                  <h3>CAPSTONE PRESENTATION</h3>
                  <span>Michael Smith</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
